import { AnyAction } from 'redux'

import { ErrorType } from 'types/index'

const moduleName = 'MMB/toast'

export enum ToastActionType {
  SHOW_TOAST = 'SHOW_TOAST',
  HIDE_TOAST = 'HIDE_TOAST',
}
export enum ToastPositions {
  TOP = 'top',
  BOTTOM = 'bottom',
}

let toastTimeout

const initialState = {
  visible: false,
  position: null,
  closable: false,
  timeout: null,
  alert: null,
}
const defaultOptions = {
  visible: false,
  position: ToastPositions.TOP,
  closable: false,
  timeout: 5000,
}

export default function reducer(state: ToastState = initialState, action: AnyAction): ToastState {
  switch (action.type) {
    case `${moduleName}/${ToastActionType.SHOW_TOAST}`:
      return {
        ...state,
        visible: true,
        position: action.position,
        closable: action.closable,
        alert: action.alert,
      }
    case `${moduleName}/${ToastActionType.HIDE_TOAST}`:
      return {
        ...state,
        visible: false,
      }
    default:
      return state
  }
}

export function showToastAction(alert: ErrorType, options: ToastOptionsType = {}) {
  return (dispatch) => {
    const optionsWithDefaults = Object.assign(defaultOptions, options)
    if (optionsWithDefaults.timeout) {
      if (toastTimeout) clearTimeout(toastTimeout)
      toastTimeout = setTimeout(() => dispatch(hideToastAction()), optionsWithDefaults.timeout)
    }
    dispatch({
      type: `${moduleName}/${ToastActionType.SHOW_TOAST}`,
      alert,
      ...optionsWithDefaults,
    })
  }
}

export function hideToastAction() {
  return (dispatch) => {
    if (toastTimeout) clearTimeout(toastTimeout)
    dispatch({
      type: `${moduleName}/${ToastActionType.HIDE_TOAST}`,
    })
  }
}

export type ToastState = {
  visible: boolean,
  position?: ToastPositions,
  closable: boolean,
  timeout?: number | null,
  alert: ErrorType | null,
}

export type ToastOptionsType = {
  closable?: boolean,
}